export default {
    'diagram4-1-4': {
        's': 'S = Hoped to offset unexpected earnings decline with additional $10b cut in operating costs.',
        's-a': 'S = Planned X to deal with Y problem',
        'c': 'C = But related short-term increases in operating costs also likely, meaning must instead look for savings in fixed costs (difficult to get at)',
        'c-a': 'C = Won’t work, have to do Z instead (diffcult)',
        'q': 'Q = (Can we realistically expect to cut $10b from our fixed costs?',
        'q-a': 'Q = Can we?',
        'a': 'A = Yes'
    }
}



// WEBPACK FOOTER //
// ./client/app/components/diagrams/4/4a/diagram4/i18n/en.js